module.exports = __webpack_public_path__ + "static/img/ind_ban_03.94b24576.jpeg";